export default __webpack_public_path__ + "static/media/completed.7e3f0698.svg";